import { PermissionLegacy } from '../permission';

export enum ChatRoomType {
	Group = 0,
	DirectMessage = 1,
}

export type ModerationType = 0 | 1 | 2; // 0=None, 1=Manual, 2=Automatic

export type ChatRoomUserRole = 0 | 1 | 2; // 0=User, 1=Moderator, 2=Admin

export type ChatRoom = {
	Id: number;
	ExternalName: string;
	InternalName: string;
	Description: string;
	IsActive: boolean;
	OpenDateUTC: Date;
	CloseDateUTC: Date;
	PortalId: number;
	CultureId: number;
	VisibleUserList: boolean;
	Type: ChatRoomType;
	LinkedObjectType: number | null; // ObjectType enum
	LinkedObjectId: number | null;
	ModerationType: ModerationType;
	Permissions: PermissionLegacy[];
	Members: ChatRoomMember[];
};

export type ChatRoomMember = {
	Id: number;
	ChatRoomId: number;
	UserId: number;
	Role: ChatRoomUserRole;
	IsMuted: boolean;
	IsBanned: boolean;
	MutedUntil: Date | null;
	BannedUntil: Date | null;
	JoinedUTC: Date;
	LastSeenUTC: Date | null;
	IsDeleted: boolean;
	UserName: string;
	UserDisplayName: string;
	UserPhoto: string;
	UserAvatar: string;
};

export type ChatNotDeliveredMessagesCount = {
	ChatRoomId: number;
	NewMessagesCount: number;
};

export type CreateChatRoomRequest = {
	ExternalName: string;
	InternalName?: string;
	Description: string;
	IsActive: boolean;
	OpenDateUTC: Date;
	CloseDateUTC: Date;
	CultureId: number;
	VisibleUserList: boolean;
	Type: ChatRoomType;
	LinkedObjectType?: number; // ObjectType enum
	LinkedObjectId?: number;
	ModerationType: ModerationType;
	Permissions?: PermissionLegacy[];
};

export type AddUserToChatRoomRequest = {
	chatRoomId: number;
	userId: number;
	role: ChatRoomUserRole;
};

export type MuteUserRequest = {
	chatRoomId: number;
	userId: number;
	mutedUntil?: Date;
};

export type BanUserRequest = {
	chatRoomId: number;
	userId: number;
	bannedUntil?: Date;
};

export type PromoteUserRequest = {
	chatRoomId: number;
	userId: number;
	newRole: ChatRoomUserRole;
};
